import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { AppRoutes } from './app.routes';
import 'rxjs/add/operator/toPromise';
import { Ng2Webstorage } from 'ngx-webstorage';
import { BusyModule } from 'angular2-busy';
import {  GrowlModule } from 'primeng/primeng';

import { LOCALE_ID } from '@angular/core';
import { AppComponent } from './app.component';
import { AppMenuComponent, AppSubMenu } from './app.menu.component';
import { AppTopBar } from './app.topbar.component';
import { AppFooter } from './app.footer.component';
import { InlineProfileComponent } from './app.profile.component';





import { NgxPermissionsModule } from 'ngx-permissions';

@NgModule({
      imports: [
            BrowserModule,
            FormsModule,
            ReactiveFormsModule,
            AppRoutes,
            HttpModule,
            BrowserAnimationsModule,
            GrowlModule,
            Ng2Webstorage,
            BusyModule,
            NgxPermissionsModule.forRoot()
      ],
      declarations: [
            AppComponent,
            AppMenuComponent,
            AppSubMenu,
            AppTopBar,
            AppFooter,
            InlineProfileComponent
      ],
      providers: [
            { provide: LocationStrategy, useClass: HashLocationStrategy },
            { provide: LOCALE_ID, useValue: 'es-EC' },

      ],
      bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts